import { multiplication } from './decimal';

interface CalcProductionCostProps {
  toAdd: number;
  recipeForProduction: Record<string, number>;
}

const calcProductionCost = ({
  toAdd,
  recipeForProduction,
}: CalcProductionCostProps): Record<string, number> => {
  const result: Record<string, number> = {};

  for (const resource in recipeForProduction) {
    const baseValue = recipeForProduction[resource];
    result[resource] = multiplication(baseValue, toAdd);
  }

  return result;
};

export { calcProductionCost };
